import i18n from 'i18next';

export default {
    type: 'postProcessor',
    name: 'OdigeoCMS',
    process: (value, [key], options) => {
        if (value === key && options.count !== undefined && !options.context) {
            const context = options.count === 0 ? 'none' : 'some';
            return i18n.t(key, { ...options, context });
        }

        return value;
    },
};
